(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wasp-lamps-quick-shop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-wl-variant]')) return;
    const option = select.selectedOptions[0];
    const image = document.getElementById(select.dataset.imageId);
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
      image.alt = select.closest('.wl__card').querySelector('h2').textContent + ' — ' + option.textContent;
    }
    select.closest('.wl__card').querySelector('[data-wl-price]').textContent = option.dataset.price;
  });

  } catch(e) { console.error(e); }
})();
})();
